<template>
  <a>
    <slot></slot>
  </a>
</template>

<script>
export default {};
</script>
